import { configureStore } from '@reduxjs/toolkit';

import selServReducer from './reducers/selServReducer';
import yourInfoReducer from './reducers/yourInfoReducer';
import primConReducer from './reducers/primConReducer';
import secConReducer from './reducers/secConReducer';
import companiesReducer from './reducers/companiesReducer';
import companyInfoReducer from './reducers/companyInfoReducer';
import pathsReducer from './reducers/pathsReducer';
import scrollReducer from './reducers/scrollReducer';
import scrollMobileReducer from './reducers/scrollMobileReducer';
import promoCodeReducer from './reducers/promoCodeReducer';
import skipSecContReducer from './reducers/skipSecContReducer';
import registrationSettingsReducer from './reducers/registrationSettingsReducer'

const store = configureStore({
    reducer: {
        companies: companiesReducer,
        companyInformation: companyInfoReducer,
        selectedServices: selServReducer,
        yourInformation: yourInfoReducer,
        primContract: primConReducer,
        secContract: secConReducer,
        promoCode: promoCodeReducer,
        skipSecCon: skipSecContReducer,
        paths: pathsReducer,
        scroll: scrollReducer,
        scrollMobile: scrollMobileReducer,
        registrationSettings: registrationSettingsReducer
    }
})

export default store
